import { createAkiliApi } from '../../utils/api/api-methods'

/*
  POST /v1/claim — Auth0 JWT authorizer. Idempotent for the same account.

  200 - { status: 'active', starts_at, ends_at, account_email, subscription? }
        subscription: { ends_at, store, will_renew }, only when the patient
        already pays for EndeavorOTC and the two months start after it
  400 - invalid_request
  401 - no_account_id (rejected by APIService as Error('INVALID_USER');
        the parsed body is attached as err.responsePayload)
  404 - not_found
  409 - already_claimed (by another account)
        access_active: another practice order on this account is still
        running. Also { active_until, link_expires_at }
  410 - expired | refunded
  502 - entitlement_error

  Error body: { code, message }
*/

type Data = {
  token: string
}

type RequestData = {
  token: string
}

type ErrorResponse = {
  success: false
  status: 400 | 404 | 409 | 410 | 500 | 502 | 503 | number | null | undefined
  localizedErrorMessage: string | null
  requestParams: RequestData
  responsePayload: {
    code?: string
    message?: string
    activeUntil?: string
    linkExpiresAt?: string | null
  }
}

// The patient's own subscription. store is RevenueCat's: app_store, play_store, stripe, ...
export type ClaimSubscription = {
  endsAt: string
  store: string
  willRenew: boolean
}

export type ClaimResult = {
  status: 'active'
  startsAt: string
  endsAt: string
  accountEmail: string
  subscription?: ClaimSubscription
}

type SuccessResponse = {
  success: true
  status: 200
  requestParams: RequestData
  responsePayload: ClaimResult
}

export type ClaimAccessResponse = ErrorResponse | SuccessResponse

const url = 'claim'
const name = 'claimAccess'

const claimAccessAPI = (
  authToken: string,
  token: string
): Promise<ClaimAccessResponse> => {
  const payload: Data = { token }

  return createAkiliApi(authToken, url, 'POST', name, payload)
}

export default claimAccessAPI
